export default __webpack_public_path__ + "static/media/maxine_detail1.a9bcf3b3.jpg";